import jsonata from "jsonata";

async function jsonataQuery(working, command, p) {
  const expr = command.getArg("expr");

  const data = JSON.parse(working.text);

  let result;
  try {
    result = await jsonata(expr).evaluate(data);
  } catch (e) {
    throw new Error(`JSONata expression failed to evaluate: ${e.message}`);
  }

  return typeof result === "object" ? JSON.stringify(result) : String(result);
}

// Meta

jsonataQuery.key = "jsonata";
jsonataQuery.title = "JSONata Query";
jsonataQuery.category = "Output Formatting";
jsonataQuery.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/jsonata/";
jsonataQuery.description = "Apply a JSONata expression to transform JSON data.";
jsonataQuery.args = [
  {
    name: "expr",
    type: "string",
    description: "JSONata expression to evaluate",
  },
];
jsonataQuery.parseValidators = [
  {
    test: (command) => {
      return command.hasArg("expr");
    },
    message: "You must provide a JSONata expression.",
  },
];

export default jsonataQuery;
